export const GEOLOCATION = {
  cookieName: '_bh_gloc',
};

export const USER_LOCATION = {
  cookieName: '_bh_uloc',
  /** Days to persist user-shared location cookie */
  expires: 90,
};
